import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchApplicantFormFailure,
  fetchApplicantFormSuccess,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';

const { FORM_DATA_REPOSITORY } = urls || {};

function* fetchApplicantForm({ payload: formId }) {
  const url = `${FORM_DATA_REPOSITORY}/forms/${formId}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchApplicantFormSuccess(response?.raw || []));
  } else {
    yield put(fetchApplicantFormFailure(response.message));
  }
}

export function* getApplicantForm() {
  yield takeEvery(
    ApplicantsActionTypes.START_FETCH_APPLICANTS_FORM,
    fetchApplicantForm
  );
}
